export default __webpack_public_path__ + "static/how-to-pick-the-right-credit-card-for-your-travel-7b4e1209d95a2c608862b6b41e0e123b.jpg";